import React from "react";

import styled from "styled-components";
import { Icons } from "./icons";

const SocialMediaLinks = () => {
  return (
    <Container>
      <Icon>{Icons.instagram}</Icon>
      <Icon>{Icons.tiktok}</Icon>
      <Icon>{Icons.x}</Icon>
      <Icon>{Icons.facebook}</Icon>
      <Icon>{Icons.youtube}</Icon>
      <Icon>{Icons.mail}</Icon>
    </Container>
  );
};

export default SocialMediaLinks;

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  margin-top: 3rem;
  @media only screen and (max-width: 769px) {
    margin-top: 23rem;
  }
`;

const Icon = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  margin-right: 1.2rem;
  cursor: pointer;
  @media only screen and (max-width: 769px) {
    width: 2.4rem;
    height: 2.4rem;
  }
`;
